import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ToastService } from '@portal-front/design-system-angular';

@Component({
  selector: 'ef-defer-error',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class EfDeferErrorComponent implements OnInit {
  public readonly toastService = inject(ToastService);

  public ngOnInit(): void {
    this.toastService.showGenericError();
  }
}
